<div class="mr-3" style="min-width: 250px;">
    <toggle-button-group
        *ngIf="context.viewStateLoaded()" 
        style="min-width: 250px;"
        class="w-25"
        [options]="context.viewButtons()"
        [initialValue]="context.initialViewButton()"
        (onSelectedChange)="context.onViewChange()($event)"
        [hidden]="context.shouldBeHidden()"
        >
    </toggle-button-group>
</div>
